import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { apiInstance } from '../axiosApi';

const initialState = {
  callSummary: [],
  loginSummary: null
};

export const getAgentLoginSummary = createAsyncThunk('callex/agent_login_summary', async () => {
  return await apiInstance.post('/user_dashboard/agent_login_summary', {});
});

export const getAgentCallSummary = createAsyncThunk('callex/agent_call_summary', async () => {
  return await apiInstance.post('/user_dashboard/agent_call_summary', {});
});

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearDashboardSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(getAgentCallSummary.fulfilled, (state, action) => {
      state.callSummary = action?.payload?.data?.call_summary || [];
    });
    builder.addCase(getAgentLoginSummary.fulfilled, (state, action) => {
      state.loginSummary = action?.payload?.data || null;
    });
  }
});

export default dashboardSlice.reducer;
export const { clearDashboardSlice } = dashboardSlice.actions;

export const selectCallSummary = (state) => state.dashboard.callSummary;
export const useCallSummary = () => {
  const callSummary = useSelector(selectCallSummary);
  return useMemo(() => callSummary, [callSummary]);
};

export const selectLoginSummary = (state) => state.dashboard.loginSummary;
export const useLoginSummary = () => {
  const loginSummary = useSelector(selectLoginSummary);
  return useMemo(() => loginSummary, [loginSummary]);
};
